export const Footer = () => {
  return (
    <footer
      className="mt-auto"
      style={{
        backgroundColor: 'var(--bg-inverse)',
        borderTop: '1px solid var(--color-neutral-800)',
      }}
    >
      <div
        className="container-main"
        style={{
          paddingTop: 'var(--space-10)',
          paddingBottom: 'var(--space-10)',
        }}
      >
        {/* Top row: nav columns */}
        <div
          className="flex flex-col sm:flex-row justify-between"
          style={{ gap: 'var(--space-8)' }}
        >
          {/* Brand */}
          <div>
            <img
              src="https://cdn.ribbonstudios.net/web/Longform_Transparent_White.png"
              alt="Ribbon Studios"
              width={53}
              height={32}
              style={{ height: '2rem', width: 'auto' }}
            />
            <p
              style={{
                marginTop: 'var(--space-2)',
                fontSize: 'var(--text-sm)',
                color: 'var(--color-neutral-400)',
              }}
            >
              Custom 3D printing services
            </p>
          </div>

          {/* Shop links */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
            <FooterHeading>Shop</FooterHeading>
            <FooterLink href="/catalog">Catalog</FooterLink>
            <FooterLink href="/quote">Get a Quote</FooterLink>
            <FooterLink href="/about">About</FooterLink>
          </div>

          {/* Legal links */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
            <FooterHeading>Legal</FooterHeading>
            <FooterLink href="https://www.ribbonstudios.org/privacy-policy/" external>
              Privacy Policy
            </FooterLink>
            <FooterLink href="https://www.ribbonstudios.org/terms-and-conditions/" external>
              Terms &amp; Conditions
            </FooterLink>
            <FooterLink href="https://www.ribbonstudios.org/cookie-policy/" external>
              Cookie Policy
            </FooterLink>
            <FooterLink href="https://www.ribbonstudios.org/disclaimer/" external>
              Disclaimer
            </FooterLink>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          style={{
            marginTop: 'var(--space-8)',
            paddingTop: 'var(--space-6)',
            borderTop: '1px solid var(--color-neutral-800)',
          }}
        >
          <p
            style={{
              fontSize: 'var(--text-sm)',
              color: 'var(--color-neutral-400)',
            }}
          >
            &copy; {new Date().getFullYear()} Ribbon Studios LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

const FooterHeading = ({ children }: { children: React.ReactNode }) => (
  <p
    style={{
      fontSize: 'var(--text-xs)',
      fontWeight: 'var(--font-weight-semibold)',
      textTransform: 'uppercase',
      letterSpacing: 'var(--tracking-wide)',
      color: 'var(--color-neutral-300)',
      marginBottom: 'var(--space-1)',
    }}
  >
    {children}
  </p>
);

const FooterLink = ({
  href,
  children,
  external = false,
}: {
  href: string;
  children: React.ReactNode;
  external?: boolean;
}) => (
  <a
    href={href}
    {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    style={{
      color: 'var(--color-neutral-400)',
      fontSize: 'var(--text-sm)',
      textDecoration: 'none',
      transition: `color var(--duration-fast) var(--ease-out)`,
    }}
    onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--text-inverse)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--color-neutral-400)'; }}
  >
    {children}
  </a>
);
